import SubscriptionPlan from "../types/enums/SubscriptionPlan"

const SubscriptionPlanTitles: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.E_PLUS]: "E+",
  [SubscriptionPlan.CONNECT]: "Connect",
  [SubscriptionPlan.NETWORK]: "Network",
  [SubscriptionPlan.PLUS]: "Plus",
  [SubscriptionPlan.PLUS_MAY_2025]: "Plus May 2025",
  [SubscriptionPlan.BASIC]: "Basic",
  [SubscriptionPlan.BASIC_MAY_2025]: "Basic May 2025",
  [SubscriptionPlan.GO]: "Go",
  [SubscriptionPlan.SUPREME]: "Supreme",
  [SubscriptionPlan.BASIC_OCT_2025]: "Basic October 2025",
}

export const OldSubscriptionPlanTitles: Record<SubscriptionPlan, string> = {
  ...SubscriptionPlanTitles,
  [SubscriptionPlan.BASIC_MAY_2025]: "Basic",
  [SubscriptionPlan.BASIC_OCT_2025]: "Basic",
  [SubscriptionPlan.PLUS_MAY_2025]: "Plus",
}

export default SubscriptionPlanTitles
